import { OAUTH2_AUTHORIZATION_COGNITO } from './EsConstants';

/**
 * Where esback answers: the page's own origin, everywhere.
 *
 * Deployed, the ALB splits escapade.gg by path; compose has nginx do the same
 * on 3080; and since 2026-09-23 the webpack dev server does it on 3000,
 * proxying /api/, /oauth2/, /login/ and /health to esback on 3100 (see its
 * proxy block). So there is nothing left to compute, and this is absolute only
 * so an href built from it reads the same wherever it is copied to.
 *
 * It used to swap :3000 for :3100, which made a laptop the one place the SPA
 * was two origins: every call a credentialed cross-origin fetch, allowed by a
 * CORS list in esback's local profile that had to name every alder machine by
 * both of its names. Over https that shape needed the certificate on two ports
 * and every Cognito callback twice, and it was the only reason esback had a
 * CORS list at all.
 *
 * Read through esFetch, not directly: EsFetch.js is where an API call gets its
 * cookies. The one other reader is EsNavBar's logout, which is neither a fetch
 * nor, since CSRF went on, a link a browser may simply follow -- it submits a
 * generated form, and the mechanism is esSubmitLogout in EsFetch.js beside the
 * token reader it needs. The href that reader builds is what the anchor still
 * points at.
 */
export const serverUrl = window.location.origin;

/**
 * Where "Login with Google" and "Register with Google" send the browser.
 *
 * <p>Spring Security's own authorization endpoint, reached on esback through
 * whatever fronts it -- the ALB, compose's nginx, or the dev server's proxy.
 * Built from serverUrl because the dev server was once a second origin and a bare
 * "/oauth2/..." there answered index.html. Absolute, it states where it goes.
 */
export const googleAuthUrl = () => serverUrl + OAUTH2_AUTHORIZATION_COGNITO;

/**
 * Leave the SPA, properly.
 *
 * <p>Named because the boundary is worth naming: everything else in this app
 * moves between routes with react-router and never reloads, and the two places
 * that go to Cognito are doing something categorically different -- a real
 * browser navigation to another origin, carrying cookies, that will come back
 * as a fresh page load.
 *
 * <p><b>Never a fetch.</b> The target is a redirect chain to Cognito's hosted UI
 * and then to Google; an XHR cannot follow it, and the session cookie has to
 * travel with the request because the tier a register page stashed lives on
 * that session.
 */
export const esHardNavigate = ( pUrl ) => { window.location.assign( pUrl ); };
